import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import {
    Injectable, inject
} from "@angular/core";
import {
    DealsApiDocVersion, DealsApiDocsSubmission, DocsResponse, RequestUtil
} from "@shopliftr/common-js/shared";
import { IInternalApiClient } from "@shopliftr/common-ng";
import { InternalApiRequestService } from "../../request/internal-api/internal-api-request.service";

/**
 * API Client Service for fetching Deals API OpenAPI documentation.
 *
 * Submit-only client — has no CRUD surface. Submits a `DealsApiDocsSubmission` to
 * `POST /v2/deals-api/docs` and returns the raw OpenAPI document body.
 *
 * @pattern submit-only api-client (see ProductApiClientService.dealsApiSearch$)
 * @implements {IInternalApiClient} Base internal API client pattern (basePath only)
 * @providedIn root
 */
@Injectable({ providedIn: "root" })
export class DocsApiClientService implements IInternalApiClient {

    readonly basePath = "deals-api";

    private readonly _internalApiRequestService = inject(InternalApiRequestService);

    /**
     * Retrieves the Deals API OpenAPI document for the given version.
     *
     * @param version - The Deals API doc version to retrieve
     * @returns Observable of the `DocsResponse` payload (its `body` is the raw OpenAPI YAML document)
     */
    getDocs$(version: DealsApiDocVersion): Observable<DocsResponse> {
        const submission = new DealsApiDocsSubmission();
        submission.version = version;
        const request = RequestUtil.createSubmitRequest(submission);
        return this._internalApiRequestService.submit$<DealsApiDocsSubmission, DocsResponse>(
            request, `${this.basePath}/docs`
        ).pipe(map((response) => response.payload));
    }
}
